import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader';

export const ButtonSkeletonLoader = () => {
  return <SkeletonLoader height={56} />;
};
